/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy } from './get-payment-request-detail200-response-comments-inner-commented-by';

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseCommentsInner
 */
export interface GetPaymentRequestDetail200ResponseCommentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'notificateTarget': GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'commentedAt': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'commentedBy': GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy;
}

export const GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum = {
    approverCandidate: 'APPROVER_CANDIDATE',
    applicant: 'APPLICANT'
} as const;

export type GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum = typeof GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum[keyof typeof GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum];


